import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { convertDate } from "../../../../../../../../helpers/date/convertDate";

const borderColor = "#424949";
const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    borderLeftColor: borderColor,
    borderLeftWidth: 1,
    borderRightColor: borderColor,
    borderRightWidth: 1,
    borderBottomColor: borderColor,
    borderBottomWidth: 1,
    alignItems: "stretch",
    alignSelf: "center",
    justifyContent: "center",
    minHeight: 14,
    fontStyle: "bold",
  },
  index: {
    width: "7%",
    textAlign: "center",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    // paddingLeft: 1,
    paddingTop: 2,
    paddingBottom: 2,
    fontSize: 7,
  },
  fulldate: {
    width: "7%",
    textAlign: "left",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingTop: 2,
    paddingRight: 8,
    paddingBottom: 2,
    marginLeft: 2,
    fontSize: 7,
  },
  fullTime: {
    width: "7%",
    textAlign: "left",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingTop: 2,
    paddingRight: 8,
    paddingBottom: 2,
    marginLeft: 2,
    fontSize: 7,
  },
  phone: {
    width: "14%",
    textAlign: "left",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingTop: 2,
    paddingRight: 8,
    paddingBottom: 2,
    marginLeft: 2,
    fontSize: 7,
  },
  origin: {
    width: "32%",
    textAlign: "left",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingTop: 2,
    paddingRight: 8,
    paddingBottom: 2,
    marginLeft: 2,
    fontSize: 7,
  },
  destination: {
    width: "32%",
    textAlign: "left",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingTop: 2,
    paddingRight: 8,
    paddingBottom: 2,
    marginLeft: 2,
    fontSize: 7,
  },
  toll: {
    width: "6%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "right",
    paddingTop: 2,
    paddingRight: 4,
    paddingBottom: 2,
    fontSize: 8,
  },
  price: {
    width: "9%",
    // borderRightColor: borderColor,
    // borderRightWidth: 1,
    textAlign: "right",
    paddingTop: 2,
    paddingRight: 6,
    paddingBottom: 2,
    fontSize: 8,
  },
});

const stylesHour = StyleSheet.create({
  row: {
    flexDirection: "row",
    borderLeftColor: borderColor,
    borderLeftWidth: 1,
    borderRightColor: borderColor,
    borderRightWidth: 1,
    borderBottomColor: borderColor,
    borderBottomWidth: 1,
    alignItems: "stretch",
    alignSelf: "center",
    justifyContent: "center",
    minHeight: 50,
    fontStyle: "bold",
  },
  index: {
    width: "7%",
    textAlign: "center",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    // paddingLeft: 1,
    paddingTop: 2,
    paddingBottom: 2,
    fontSize: 7,
  },
  fulldate: {
    width: "14%",
    textAlign: "left",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingTop: 2,
    paddingRight: 7,
    paddingBottom: 2,
    marginLeft: 2,
    fontSize: 6.5,
  },
  origin: {
    width: "64%",
    textAlign: "left",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingTop: 2,
    paddingRight: 8,
    paddingBottom: 2,
    marginLeft: 2,
    fontSize: 7,
  },
  phone: {
    width: "14%",
    textAlign: "left",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingTop: 2,
    paddingRight: 8,
    paddingBottom: 2,
    marginLeft: 2,
    fontSize: 7,
  },
  toll: {
    width: "6%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "right",
    paddingTop: 2,
    paddingRight: 4,
    paddingBottom: 2,
    fontSize: 8,
  },
  price: {
    width: "9%",
    // borderRightColor: borderColor,
    // borderRightWidth: 1,
    textAlign: "right",
    paddingTop: 2,
    paddingRight: 6,
    paddingBottom: 2,
    fontSize: 8,
  },
});

function getSubRoutesList(subRoutes) {
  if (!subRoutes) return [];

  try {
    const routes =
      typeof subRoutes === "string" ? JSON.parse(subRoutes) : subRoutes;
    const routeList = Array.isArray(routes) ? routes : Object.values(routes);

    return routeList
      .filter((subRoute) => subRoute?.name)
      .sort((a, b) => Number(a?.id || 0) - Number(b?.id || 0));
  } catch (error) {
    return [];
  }
}

function getDestinationText(item) {
  const subRoutes = getSubRoutesList(item.sub_routes);

  if (subRoutes.length === 0) return item.destination_name;

  const destinationRoute = {
    id: subRoutes.length + 1,
    name: item.destination_name,
  };
  const routes = [...subRoutes, destinationRoute].filter(
    (route) => route?.name,
  );

  return routes.map((route, index) => `${index + 1}. ${route.name}`).join("\n");
}

const TableRow = ({ items }) => {
  const compareByDate = (a, b) => {
    const dateB = convertDate(b.date, a.time);
    const dateA = convertDate(a.date, a.time);
    return dateB - dateA;
  };
  const Br = () => "\n";
  const rows = items.sort(compareByDate).map((item) =>
    !item.dateEnd ? (
      <Fragment key={item.id.toString()}>
        <View style={styles.row}>
          <Text style={styles.index}>{item.order_number}</Text>
          <Text style={styles.fulldate}>{item.date}</Text>
          <Text style={styles.fullTime}>{item.time}</Text>
          <Text style={styles.origin}>{item.origin_name}</Text>
          <Text style={styles.destination}>{getDestinationText(item)}</Text>
          <Text style={styles.toll}>{item.toll}</Text>
          <Text style={styles.price}>{Number(item.payment_price_total).toFixed(2)}</Text>
          {/* <Text style={styles.rate}>{item.rate}</Text>
      <Text style={styles.amount}>{(item.qty * item.rate).toFixed(2)}</Text> */}
        </View>
      </Fragment>
    ) : (
      <Fragment key={item.id.toString()}>
        <View style={stylesHour.row}>
          <Text style={stylesHour.index}>{item.order_number}</Text>
          <Text style={stylesHour.fulldate}>
            {item.date} {item.time}
            <Br />
            {item.dateEnd} {item.timeEnd}
          </Text>
          <Text style={stylesHour.origin}>
            ORIGEN: {item.origin_name}
            <Br />
            {item.note}
            <Br />
            DESTINO: {getDestinationText(item)}
          </Text>
          <Text style={stylesHour.toll}>{item.toll}</Text>
          <Text style={stylesHour.price}>{Number(item.payment_price_total).toFixed(2)}</Text>
        </View>
      </Fragment>
    )
  );
  return <Fragment>{rows}</Fragment>;
};

export default TableRow;
